<template>
    <div id="app">
        <Dialog/>
        <router-view/>
    </div>
</template>
<script>
import Dialog from '@/shared/components/ui/Dialog'
export default {
    components: {
        Dialog
    },
}
</script>